module.exports = __webpack_public_path__ + "img/open-ai.600a1fb8.svg";